import React from "react"
import { Alert, Box, Button, ForwardIcon, Typography } from "@carrotfertility/carotene-core"

import { FormattedMessage, FormattedNumber } from "react-intl"

import type { InsuranceInputs, InsuranceResult } from "../../insuranceTypes"
type Props = { inputs: InsuranceInputs; result: InsuranceResult; onContinue: () => void }
export function InsuranceCoveredStep({ inputs, result, onContinue }: Props): JSX.Element {
  return (
    <Box
      sx={(theme) => ({
        inlineSize: "100%",
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(theme.tokens.spacing.lg)
      })}
    >
      <Alert severity="success">
        <FormattedMessage
          defaultMessage="You're covered by {insuranceProvider} for this visit"
          values={{
            insuranceProvider: inputs?.payerName
          }}
        />
      </Alert>
      <Box>
        {result?.patientResponsibility ? (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                gap: (theme) => theme.spacing(theme.tokens.spacing.sm)
              }}
            >
              <Typography variant="h3" component="h1">
                <FormattedMessage defaultMessage="Your estimated cost:" />
              </Typography>
              <Typography variant="h3" component="span">
                <FormattedNumber
                  value={result.patientResponsibility.estimate.total / 100}
                  // eslint-disable-next-line react/style-prop-object -- style prop is valid for FormattedNumber
                  style="currency"
                  currency="USD"
                  minimumFractionDigits={result.patientResponsibility.estimate.total % 100 === 0 ? 0 : 2}
                  maximumFractionDigits={2}
                />
              </Typography>
            </Box>
          </>
        ) : (
          <FormattedMessage defaultMessage="A cost estimate is not available for this visit." />
        )}
      </Box>
      <Typography>
        <FormattedMessage defaultMessage="This is an estimate. Your final cost is determined after your insurance claim is processed and may be a little different." />
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="outlined" color="secondary" onClick={() => onContinue()} endIcon={<ForwardIcon />}>
          <FormattedMessage defaultMessage="Choose a time" />
        </Button>
      </Box>
    </Box>
  )
}
